/* global debounce */

if (!customElements.get('pp-facet-filters')) {
  class PpFacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('#facets');
      this.resultsTargetId = this.dataset.resultsTarget || 'pp-filter-results';
      this.resultsUrl = this.dataset.resultsUrl; // collection URL (e.g. /collections/portable-power-stations)

      this.resultsWrap = document.getElementById(this.resultsTargetId);

      if (!this.form || !this.resultsUrl || !this.resultsWrap) return;

      this.form.addEventListener('input', debounce(this.handleChange.bind(this), 350));
      this.form.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(e) {
      const t = e.target;

      // Clear filter links inside facet-filters snippet
      if (t && t.matches('.js-clear-filter, .js-clear-all')) {
        e.preventDefault();
        const url = new URL(t.href, window.location.origin);
        this.apply(url.searchParams.toString());
      }
    }

    handleChange() {
      const formData = new FormData(this.form);
      const params = new URLSearchParams(formData);

      // Remove empty
      [...params.keys()].forEach((k) => {
        if (!params.get(k)) params.delete(k);
      });

      this.apply(params.toString());
    }

    async apply(searchParams) {
      this.resultsWrap.classList.add('is-loading');

      // KEY: fetch your OWN renderer section, not the whole collection template
      const url = `${this.resultsUrl}?${searchParams}&section_id=pp-landing-filter-results`;

      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) {
        this.resultsWrap.classList.remove('is-loading');
        return;
      }

      const htmlText = await res.text();
      const tmpl = document.createElement('template');
      tmpl.innerHTML = htmlText;

      // Shopify returns section HTML; we just need the #filter-results content
      const incoming = tmpl.content.querySelector('#filter-results');
      if (incoming) {
        // Replace only the results area with our same structure
        const current = this.resultsWrap.querySelector('#filter-results');
        if (current) current.replaceWith(incoming);
        else this.resultsWrap.appendChild(incoming);
      }

      // Update URL (optional but nice)
      history.pushState({ searchParams }, '', `${this.resultsUrl}${searchParams ? '?' + searchParams : ''}`);

      this.resultsWrap.classList.remove('is-loading');

      // Let your “open all accordions” hook run again if you want
      document.dispatchEvent(new CustomEvent('on:facet-filters:updated', { bubbles: true }));
    }
  }

  customElements.define('pp-facet-filters', PpFacetFilters);
}
